import clientApi from '../apis/clientApi';
import aesReduxConstants from '../constants';
import contextSelectors from '../selectors/contextSelectors';

const clientActions = function() {
  const factory = {};
  const constants = aesReduxConstants.CLIENT;

  // get the list of licenses that the client has
  factory.getLicenses = function() {
    return function(dispatch, getState) {
      const state = getState();
      const clientId = contextSelectors.selectClientId(state);
      clientApi.getLicenseList(clientId)
        .then((response) => {
          const list = response.data.licenseList;
          dispatch({ type: constants.GET_CLIENT_LICENSES, licenses: list });
        }, (error) => {
        });
    };
  };

  return factory;
};

export default clientActions();
